define('taoQtiItem/qtiXmlRenderer/renderers/interactions/AssociateInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'associateInteraction',
        template : tpl
    };
});
